import $ from 'jquery';

(() => {
  $('.tab-list-item').on('click', function () {
    let index = $('.tab-list-item').index(this);

    $('.tab-list-item').removeClass('is-btn-active');
    $(this).addClass('is-btn-active');
    $('.tab-contents').removeClass('is-contents-active');
    $('.tab-contents').eq(index).addClass('is-contents-active');

    if (index === 1) {
      $('.tab-contents-wrap').addClass('is-blue');
    } else {
      $('.tab-contents-wrap').removeClass('is-blue');
    }
  });
})();
